module.exports = __webpack_public_path__ + "static/media/a.b08d6f35.jpg";